import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ToggleSwitch from './ToggleSwitch';
import './FilterModal.css';
import { useGoogleTranslate } from '../../../Hooks/useGoogleTranslate';
import TranslatedText from '../../TranslatedText';

const LanguagesModal = ({ show, onHide, value, onUpdate }) => {
  const titleLabel = useGoogleTranslate("What's their communication style?");
  const clearLabel = useGoogleTranslate('Clear');
  const applyLabel = useGoogleTranslate('Apply');
  const [selectedValues, setSelectedValues] = useState(value || []);
  const [showOthers, setShowOthers] = useState(false);

  const languageOptions = [
    'English',
    'Czech',
    'Dutch',
    'German',
    'Hebrew',
    'Japanese',
    'Norwegian',
    'Portuguese',
    'Sign language',
    'Swedish',
    'Chinese',
    'Danish',
    'French',
    'Greek',
    'Italian',
    'Korean',
    'Polish',
    'Russian',
    'Spanish',
    'Other'
  ];

  const handleOptionToggle = (option) => {
    setSelectedValues(prev =>
      prev.includes(option)
        ? prev.filter(lang => lang !== option)
        : [...prev, option]
    );
  };

  const handleApply = () => {
    onUpdate(selectedValues);
    onHide();
  };

  const handleClear = () => {
    setSelectedValues([]);
    onUpdate([]);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>{titleLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="filter-checkbox-group">
          {languageOptions.map((option) => (
            <div
              key={option}
              className={`filter-checkbox-option ${selectedValues.includes(option) ? 'selected' : ''}`}
              onClick={(e) => {
                // Only handle click if it's not on the input itself
                if (e.target.type !== 'checkbox') {
                  handleOptionToggle(option);
                }
              }}
            >
              <input
                type="checkbox"
                id={`language-${option}`}
                name="languages"
                value={option}
                checked={selectedValues.includes(option)}
                onChange={(e) => {
                  e.stopPropagation();
                  handleOptionToggle(option);
                }}
              />
              <label htmlFor={`language-${option}`}>
                <TranslatedText text={option} />
              </label>
            </div>
          ))}
        </div>

        {/* Toggle Switch */}
        <ToggleSwitch
          checked={showOthers}
          onChange={setShowOthers}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear} className="filter-modal-btn secondary">
          {clearLabel}
        </Button>
        <Button variant="primary" onClick={handleApply} className="filter-modal-btn primary">
          {applyLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LanguagesModal;
